import { USER_ROLE_NAME } from '@/service/constants';
import { FixtureComparisonRating } from '@/service/types';

export const getSupervisor = (comparisonRating?: FixtureComparisonRating[]) =>
  comparisonRating?.find(
    (scorer) => scorer.role.name === USER_ROLE_NAME.SUPERVISOR,
  )?.user.oktaId || '';
